// React libraries
import * as React from 'react';
// Custom Styles
import { useStyles } from "./ListSelectionModalStyles";
// Material-UI Core
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Modal } from "../../index";
import { GreyButton } from "../../index";
export const ListSelectionModal = (props) => {
    const classes = useStyles(props);
    const [selected, setSelected] = React.useState([]);
    const { isModalOpen, title, dataTitle, listTypes, data, showCount } = props;
    const handleSelectedChange = (value) => (e) => {
        let tempSelected = [...selected];
        if (listTypes.includes("multiple_order")) {
            if (tempSelected.includes(value)) {
                const index = tempSelected.indexOf(value);
                if (index > -1) {
                    tempSelected.splice(index, 1);
                }
            }
            else if (value == "all_orders" || value == "add_order") {
                tempSelected = [];
                tempSelected.push(value);
            }
            else {
                if (tempSelected.includes("all_orders") || tempSelected.includes("add_order")) {
                    tempSelected = [];
                }
                tempSelected.push(value);
            }
            setSelected(tempSelected);
        }
    };
    const modalWidth = 285;
    const modalHeight = 350;
    // Reset Data On Option Change
    React.useEffect(() => {
        setSelected([]);
    }, [listTypes]);
    return (React.createElement(Modal, { isModalOpen: isModalOpen, width: modalWidth, height: modalHeight },
        React.createElement("div", { className: classes.floatingDiv },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivBarTop },
                    React.createElement("p", null, title)),
                React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivBarTitle },
                    React.createElement("p", null, dataTitle)),
                React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivContentWithTitle, style: { height: `calc(${modalHeight}px - 50px - 50px - 40px)` } },
                    listTypes.includes("all") && (React.createElement(Button, { className: classes.floatingDivContentButton + " " + (selected.includes("all_orders") ? classes.floatingDivContentButtonSelected : ""), value: "all_orders", onClick: handleSelectedChange("all_orders") }, "All Orders")),
                    data.map((data) => (React.createElement(Button, { className: classes.floatingDivContentButton + " " + (selected.includes(data.name) ? classes.floatingDivContentButtonSelected : ""), value: data.name, onClick: handleSelectedChange(data.name) },
                        data.name,
                        " ",
                        showCount ? "(" + data.count + ")" : ""))),
                    listTypes.includes("unrelated") && (React.createElement(Button, { className: classes.floatingDivContentButton + " " + (selected.includes("add_order") ? classes.floatingDivContentButtonSelected : ""), value: "add_order", onClick: handleSelectedChange("add_order") }, "Add an Order"))),
                listTypes.includes("multiple_order") ? (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { item: true, md: 6, className: classes.floatingDivBarBottom },
                        React.createElement(GreyButton, { onClick: () => { }, type: "left" }, "Cancel")),
                    React.createElement(Grid, { item: true, md: 6, className: classes.floatingDivBarBottom },
                        React.createElement(GreyButton, { onClick: () => { }, type: "right", selected: !(selected.length < 1), disabled: selected.length < 1 }, "Confirm")))) : (React.createElement(Grid, { item: true, md: 12, className: classes.floatingDivBarBottom },
                    React.createElement(GreyButton, { onClick: () => { } }, "Cancel")))))));
};
ListSelectionModal.defaultProps = {
    selectFunction: () => { },
    setOpenModalState: () => { },
};
export default React.memo(ListSelectionModal);
